var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1508 3.36588C15.542 2.73656 16.458 2.73656 16.8492 3.36587L21.1459 10.2764C21.2836 10.4979 21.5023 10.6567 21.7554 10.7193L29.6555 12.6701C30.3749 12.8478 30.6579 13.7189 30.1803 14.2855L24.9357 20.5073C24.7677 20.7067 24.6841 20.9638 24.7029 21.2238L25.2888 29.3401C25.3421 30.0792 24.6011 30.6176 23.9147 30.3384L16.3767 27.2732C16.1352 27.175 15.8648 27.175 15.6233 27.2732L8.08532 30.3384C7.39887 30.6176 6.65788 30.0792 6.71123 29.3401L7.29709 21.2238C7.31586 20.9638 7.23232 20.7067 7.06428 20.5073L1.81969 14.2855C1.34209 13.7189 1.62512 12.8478 2.34455 12.6701L10.2446 10.7193C10.4977 10.6567 10.7164 10.4979 10.8541 10.2764L15.1508 3.36588Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L19.0153 13.8497L24.5595 15.2188L20.8789 19.5853L21.2901 25.2812L16 23.13L10.7099 25.2812L11.1211 19.5853L7.44049 15.2188L12.9847 13.8497L16 9Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterested);
export default __webpack_public_path__ + "static/media/interested.e68659ea4e3a023d0a05538a19b51ed4.svg";
export { ForwardRef as ReactComponent };